import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/toPromise';
import {Result} from '../interfaces/result.interface';

@Injectable()

export class _RuleConditionService {

  constructor(private http: HttpClient) { }

  FixAllValuesForSave(ruleCondition){

      //fix 'All' options -> null values
      if(ruleCondition.entityType == 'all'){
        ruleCondition.entityType = null;
        ruleCondition.entityID = null;
      }
      if(ruleCondition.currencyPair == 'All'){
        ruleCondition.currencyPair = null;
      }

      //remove display fields
      var fixed = {};
     for(var prop in ruleCondition) {
        if(prop.indexOf('Display') === -1 && prop != 'uid' && prop != 'uniqueid' && prop != 'boundindex' && prop != 'visibleindex' && prop != 'rowId'){
          fixed[prop] = ruleCondition[prop];
        }
      }

      return fixed;
  }

  FixAllValuesFromRead(ruleCondition){
      if(ruleCondition.entityType == null || ruleCondition.entityType == 'ORGANIZATION'){
        ruleCondition.entityType = 'all';
        ruleCondition.entityID = 0;
      }
      if(ruleCondition.currencyPair == null){
        ruleCondition.currencyPair = 'All';
      }
      return ruleCondition;
  }

  GetRuleConditions(){
      return this.http.get<any[]>('/ajax/rule-conditions').toPromise().then((result) => {
          var ruleConditions = result;
          for(var i = 0;i<ruleConditions.length;i++){
            ruleConditions[i] = this.FixAllValuesFromRead(ruleConditions[i]);
          }
          return ruleConditions;
      });
  }

  CreateRuleCondition(ruleCondition){
      return this.http.post<Result>('/ajax/rule-conditions', [ this.FixAllValuesForSave(ruleCondition) ]).toPromise().then((result) => {
         return result ? this.FixAllValuesFromRead(result) : null;
      });
  }

  UpdateRuleCondition(ruleCondition){
      return this.http.put<Result>('/ajax/rule-conditions', [ this.FixAllValuesForSave(ruleCondition) ]).toPromise().then((result) => {
          return result ? this.FixAllValuesFromRead(result) : null;
      });
  }

  DeleteRuleCondition(ruleConditionId){
    return this.http.delete<Result>('/ajax/rule-conditions/' + ruleConditionId).toPromise().then((result) => {
       return result ? result.data : null;
    });
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/ng1-services/rule-condition.service.ts